import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { PaymentTemplate } from "@/components/PaymentTemplate";

export const PreviewDialog = ({ open, onOpenChange, hotel, data }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="h-[92vh] max-w-6xl overflow-y-auto border-0 p-0" data-testid="preview-dialog">
      <DialogTitle className="sr-only">Vista previa de la plantilla</DialogTitle>
      {hotel && data && <PaymentTemplate hotel={hotel} data={data} preview />}
    </DialogContent>
  </Dialog>
);
